import { useState, useEffect, useCallback } from 'react';
import * as api from '../services/api';

interface UseStoreValidationResult {
  storeStatus: api.StoreValidationResponse | null;
  storeValidating: boolean;
  storeValidationError: string | null;
  validateStore: () => void;
}

export const useStoreValidation = (salesforceId: string | null): UseStoreValidationResult => {
  const [storeStatus, setStoreStatus] = useState<api.StoreValidationResponse | null>(null);
  const [storeValidating, setStoreValidating] = useState<boolean>(false);
  const [storeValidationError, setStoreValidationError] = useState<string | null>(null);

  
  const validateStore = useCallback(async () => {
    if (!salesforceId) {
      setStoreStatus(null);
      return;
    }

    setStoreValidating(true);
    setStoreValidationError(null);
    
    try {
      const validationResult = await api.validateStoreStatus(salesforceId);
      setStoreStatus(validationResult);
      
      if (validationResult.status === 'error') {
        setStoreValidationError(validationResult.error || 'Store validation failed');
      }
    } catch (err) {
      console.error('❌ Store validation error:', err);
      setStoreValidationError(err instanceof Error ? err.message : 'Store validation failed');
      setStoreStatus({
        status: 'error',
        message: 'Failed to validate store',
        salesforceId,
        hasStore: false,
        hasData: false
      });
    } finally {
      setStoreValidating(false);
    }
  }, [salesforceId]);

  
  useEffect(() => {
    validateStore();
  }, [validateStore]);

  return {
    storeStatus,
    storeValidating,
    storeValidationError,
    validateStore
  };
};